<div class="position-relative">
  <div class="btn color-item color-item-more"
       style="background: #e7eaef; border: 1px solid #cecece;"
       (click)="toggleColorPicker()">
    <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
  </div>
  <chrome-picker class="picker-dialog" *ngIf="isVisible" [control]="colorControl"></chrome-picker>
</div>
